module.exports = __webpack_public_path__ + "static/media/FOUNDING-03.892ebf23.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/FOUNDING-03.jpg
// module id = 202
// module chunks = 0